
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterAcdcOn as ObiConverterAcdcOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-acdc-on.js';
 
 
 

 
 export const ObiConverterAcdcOn = createComponent({
   react: React,
   tagName: 'obi-converter-acdc-on',
   elementClass: ObiConverterAcdcOnElement,
   events: {
     
   }
  });
 
 